<template>
  <BuiEntityListingPage
    v-bind="listNamesConfig"
    :ItemsLister="CampaignsLister"
    :itemsListerBind="{ buiColumns: campaignsColumns }"
    :createItemPage="canCreate"
    @create="createDialog?.openModal()"
  />

  <!-- Create Campaign modal — Phase 3 create-modal template (see PlaylistsListView). -->
  <Dialog ref="createDialog" panelClass="bui-dialog-panel">
    <template #dialog.title>Create Campaign</template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <CreateCampaignForm @cancel="closeModal" @success="closeModalAfter(1000)" />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import Dialog from '@/components/Dialog/Dialog.vue';
import CreateCampaignForm from './CreateCampaignForm/CreateCampaignForm.vue';
import CampaignsLister from './CampaignsLister/CampaignsLister.vue';
import listNamesConfig from "./CampaignsLister/config/listNames.config";
import campaignsColumns from "./CampaignsLister/config/tableColumns.config";
import useUser from '@/composables/user';

const user = useUser();
const createDialog = ref();
const canCreate = computed(() => user.hasCreateAccessToArea(listNamesConfig.areaAccessName));
</script>

<style lang="scss" scoped>
</style>
